import { createFileRoute } from '@tanstack/react-router';

import { MaterialsOnSitePage } from '@/features/resources/materials-on-site-page';

export const Route = createFileRoute('/_app/projects/$projectId/cost/materials-on-site')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <MaterialsOnSitePage projectId={projectId} />;
}
